import Helmet from "react-helmet"

// import Fallback from '../../Fallback'
// import WindowsVersionsTypist from "../Home/components/WindowsVersionsTypist"

import AppBar from "../../components/AppBar"
import Footer from "../../components/Footer"
import WindowsVersionsContent from "../../components/WindowsVersionsContent"
import HomeContent from "../Home/components/HomeContent"
import WindowsContent from "../Windows/components/WindowsContent"
import { Box, Container, Divider, Toolbar } from "@podcastsoundboard/ps-lib/ui"

export default function WindowsVersions() {
  return (
    <>
      <Helmet titleTemplate="%s">
        <title>Podcast Soundboard for Windows Downloads</title>
        <meta
          name="description"
          content="Podcast Soundboard is the best soundboard application, available on all platforms. Featuring many customization and control options and a money-back guarantee."
        />
      </Helmet>

      <AppBar
        showLogo
        invert
        title="Podcast Soundboard"
        typographyColorOverride="white"
      />
      <Box className="hero-bg-2 pb-20">
        <Toolbar />

        <Container maxWidth="lg" className="py-16">
          <WindowsVersionsContent />
        </Container>
      </Box>

      <WindowsContent />
      <HomeContent />
      <Divider />
      <Footer />
    </>
  )
}
